import { Field } from 'formik';
import ValidationError from 'gcs-common/components/Formik/ValidationError/ValidationError';
import styles from './styles.module.scss';

interface FormikOpeningHoursProps {
  disabled?: boolean;
  end1?: string;
  end2?: string;
  label?: string;
  label1?: string;
  label2?: string;
  placeholder?: string;
  start1?: string;
  start2?: string;
  textClassName?: string;
  type?: string;
}

const FormikOpeningHours = (props: FormikOpeningHoursProps) => {
  const {
    textClassName,
    disabled = true,
    label = '',
    label1 = '',
    label2 = '',
    start1 = '',
    start2 = '',
    end1 = '',
    end2 = '',
    type = 'time',
    placeholder = '',
  } = props;

  return (
    <div className={styles.formikOpeningHoursContainer}>
      <div className={`${styles.formikOpeningHoursWrapper} ${disabled ? styles.disabled : ''}`}>
        <table>
          <tbody>
            <tr>
              <th>
                <div className={styles.formikOpeningHoursLabel}>{label}</div>
              </th>
            </tr>
            <tr>
              <th>
                <div className={styles.formikOpeningHoursLabel}>{label1}</div>
              </th>
              <td>
                <Field
                  id={start1}
                  className={textClassName || styles.formikOpeningHours}
                  placeholder={placeholder}
                  type={type}
                  name={start1}
                  disabled={disabled}
                />
                <ValidationError name={start1} />
              </td>
              <td>
                <Field
                  id={end1}
                  className={textClassName || styles.formikOpeningHours}
                  placeholder={placeholder}
                  type={type}
                  name={end1}
                  disabled={disabled}
                />
                <ValidationError name={end1} />
              </td>
            </tr>
            <tr>
              <th>
                <div className={styles.formikOpeningHoursLabel}>{label2}</div>
              </th>
              <td>
                <Field
                  id={start2}
                  className={textClassName || styles.formikOpeningHours}
                  placeholder={placeholder}
                  type={type}
                  name={start2}
                  disabled={disabled}
                />
                <ValidationError name={start2} />
              </td>
              <td>
                <Field
                  id={end2}
                  className={textClassName || styles.formikOpeningHours}
                  placeholder={placeholder}
                  type={type}
                  name={end2}
                  disabled={disabled}
                />
                <ValidationError name={end2} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FormikOpeningHours;
